"use strict";

var _interopRequireDefault = require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/home/cej/Documents/VS_Code/MWeeB/nq-component/node_modules/@babel/runtime/helpers/esm/createClass.js"));
var LRUCache = /*#__PURE__*/function () {
  function LRUCache() {
    var limit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
    (0, _classCallCheck2["default"])(this, LRUCache);
    this.limit = limit;
    this.cache = new Map();
  }
  return (0, _createClass2["default"])(LRUCache, [{
    key: "get",
    value: function get(key) {
      return this.cache.get(key);
    }
  }, {
    key: "put",
    value: function put(key, value) {
      this["delete"](key); // if key already exist need to delete first to perform update
      if (this.cache.size === this.limit) {
        this["delete"](this.cache.keys().next().value);
      }
      this.cache.set(key, value);
    }
  }, {
    key: "values",
    value: function values() {
      return Array.from(this.cache.values());
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.cache["delete"](key);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.cache.clear();
    }
  }, {
    key: "size",
    value: function size() {
      return this.cache.size;
    }
  }]);
}();
var _default = exports["default"] = LRUCache;